import React, { useEffect, useState } from 'react'
import SpeedIcon from '@material-ui/icons/Speed';
// import MailOutlineOutlinedIcon from '@material-ui/icons/MailOutlineOutlined';
// import YouTubeIcon from '@material-ui/icons/YouTube';
import InputSlider from '../../components/slider';
import GoogleFixedAds from '../../components/googleAds/GoogleFixedads';
import * as Config from "../../lib/config";
import { isMobile } from 'react-device-detect';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import StaticIntroduction from './staticIntroduction'
import TextSliderSection from './textSliderSection'
import TextInputSection from './textInputSection'
// import { Adsense } from '@ctrl/react-adsense';
// import BlurEffectCom from '../../components/blurEffect';
import './home.css';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-awesome-reveal';

const metaDiscription =[
  "Our user-friendly web app allows you to effortlessly create endless scrolling text and even include emojis!",
  "Simply enter your desired text into the message box, and watch it come to life on a captivating LED display.",
  "The 'LED Scroller' All Device is the latest release that aims to enhance the impact of your events or advertisements.",
  "With 'LED Scroller', you have access to a dynamic web platform that provides an interactive LED display, allowing you to showcase your desired text, images, and messages like a vibrant LED banner. This feature enables users to create vivid and engaging presentations for their events or promotional campaigns.",
  "We prioritize aesthetics and design sensibility over flashy features, ensuring that your LED display stands out. Here's what you can do:",
  "Choose an attractive shape for your sign to create a visually appealing display.",
  "Plan the layout of your sign to optimize the presentation of your content.",
  "Select fonts that suit your style and enhance readability.",
  "Pick visually pleasing colors that capture attention and complement your message.",
  "Add eye-catching graphics to your signage to further enhance its visual appeal.",
  "Apply the blink effect to your text, creating a dynamic and attention-grabbing display.",
  "With these customizable options, you can create stunning LED displays that leave a lasting impression.",
]

const metaIntroduction = [
  "LED Advertising Scrolling Subtitles is an exceptional tool with a diverse range of applications and an aesthetically pleasing interface. This tool serves as an official version, making it well-suited for families, schools, and companies to seamlessly display work-related content and household reminders on their computers in a continuous loop.",
  "LED Scrolling Subtitles is an incredibly fascinating software designed to provide assistance and streamline various tasks."
]

const moreAbout = [
  "LED Scroller: LED Banner Maker is a versatile and user-friendly application designed to create captivating LED banners and scrolling text. Whether you're organizing an event, promoting a product, or simply want to grab attention with a dynamic display, this app has got you covered. With a wide range of features and customization options, you can unleash your creativity and make your messages shine.",
  "One of the key highlights of LED Scroller: LED Banner Maker is its intuitive interface. The app is designed to be user-friendly, ensuring that even those with minimal technical knowledge can easily navigate and create stunning LED banners. Upon launching the app, you'll be greeted with a clean and straightforward layout, making it simple to get started.",
  "To begin creating your LED banner, you can enter your desired text into the message box. The app allows you to input text of any length, providing ample space to convey your message effectively. Moreover, LED Scroller: LED Banner Maker goes beyond ordinary text by allowing you to include emojis as well. This adds a touch of fun and personality to your banners, making them more engaging and eye-catching.",
  "Once you've entered your text, the app instantly generates a preview of how your LED banner will look. This real-time preview feature enables you to make immediate adjustments and see the results in action. You can experiment with different fonts, colors, and sizes to find the perfect combination that suits your style and captures attention. LED Scroller: LED Banner Maker offers a wide range of font options, ensuring that you can find the right style to match your message.",
  "In addition to text customization, the app provides several other tools to enhance the visual appeal of your LED banner. You can choose from various shapes and layouts to create a visually appealing design. Whether you prefer a simple rectangular banner or a more unique shape, the app gives you the freedom to experiment and create a banner that stands out.",
  "Color selection is another crucial aspect of designing an impactful LED banner, and LED Scroller: LED Banner Maker offers a rich palette of colors to choose from. You can select vibrant hues that capture attention or opt for more subtle shades that convey a sense of elegance. With the color options available, you can ensure that your LED banner aligns with your brand or event theme.",
  "To further enhance the visual impact, LED Scroller: LED Banner Maker allows you to add eye-catching graphics to your LED banner. These graphics can be used to accentuate your message, highlight key information, or add a touch of creativity. The app provides a library of pre-designed graphics, or you can even import your own images for a truly personalized touch.",
  "Another noteworthy feature of LED Scroller: LED Banner Maker is the ability to apply various effects to your text. The app allows you to make your text blink, creating a dynamic and attention-grabbing display. This effect is particularly effective when used sparingly and strategically, drawing viewers' eyes to your banner and ensuring that your message doesn't go unnoticed.",
  "Once you've designed your LED banner to perfection, LED Scroller: LED Banner Maker offers multiple ways to showcase and share your creation. You can save the banner as an image or animated GIF directly to your device, allowing you to use it in various contexts. Additionally, the app provides options to share your LED banner directly to social media platforms or messaging apps, enabling you to effortlessly reach a wider audience.",
  "In conclusion, LED Scroller: LED Banner Maker is a powerful application that empowers users to create stunning LED banners and scrolling text. With its intuitive interface, customizable options, and range of effects, the app enables you to grab attention, promote your message, and leave a lasting impression. Whether you're a business owner, event organizer, or simply looking to add some flair to your messages, LED Scroller: LED Banner Maker is a must-have tool",
]
const PurpleSwitch = withStyles({
  switchBase: {
    color: Config.THEME_COLOR[300],
    '&$checked': {
      color: Config.THEME_COLOR,
    },
    '&$checked + $track': {
      backgroundColor: Config.THEME_COLOR,
    },
  },
  checked: {},
  track: {
    backgroundColor: '#fff'
  },
})(Switch);

const MirrorSwitch = withStyles({
  root:{
    width: 68,
    height: 34,
    padding: 7,
    "& .MuiSwitch-switchBase": {
      margin: 1,
      padding: 0,
      transform: "translateX(6px)",
      "&.Mui-checked": {
        transform: "translateX(30px)",
      },
    },
    "& .MuiSwitch-thumb": {
      width: 32,
      height: 32,
    },
    "& .MuiSwitch-track": {
      borderRadius: 20 / 2,
    },
  },
  switchBase: {
    color: Config.THEME_COLOR[300],
    '&$checked': {
      color: Config.THEME_COLOR,
    },
    '&$checked + $track': {
      backgroundColor: Config.THEME_COLOR,
    },
  },
  checked: {},
  track: {
    backgroundColor: '#fff'
  },
})(Switch);

const FormControlLabels = withStyles({
  root:{
    margin: '0px'
  }
})(FormControlLabel);

// const demoImages = [
//   'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=800&q=80',
//   'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80',
//   'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=800&q=80',
//   'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80',
// ];

const features = [
  { icon: '✅', title: 'Fully Responsive', desc: 'Works on all devices and screen sizes.' },
  { icon: '⚡', title: 'Fast Performance', desc: 'Lightning-fast rendering and updates.' },
  { icon: '🎨', title: 'Customizable', desc: 'Change colors, fonts, speed, and more.' },
  { icon: '🔒', title: 'Privacy Friendly', desc: 'No sign-up required, no tracking.' },
];

const whyChoose = [
  { icon: '🚀', title: 'Instant LED Banners', desc: 'Create banners for any occasion in seconds.' },
  { icon: '📱', title: 'Mobile Friendly', desc: 'Use on any device, anywhere.' },
  { icon: '🔗', title: 'Easy Sharing', desc: 'Share your creations with a click.' },
  { icon: '💡', title: 'No Coding Needed', desc: 'Simple, intuitive interface for everyone.' },
];

const faqs = [
  { q: 'Is LED Scroller free?', a: 'Yes, all features are free to use.' },
  { q: 'Can I use it for my business?', a: 'Absolutely! Many businesses use our tool for promotions and events.' },
  { q: 'How do I contact support?', a: 'Visit our Contact page for help.' },
];

const stats = [
  { label: 'Banners Created', value: 145889 },
  { label: 'Happy Users', value: 6254 },
  { label: 'Countries', value: 31 },
  { label: '5-Star Reviews', value: 278 },
];

const Home = (props) => {
  const {
    onCycleComplete,
    RGB,
    isblink,
    speed,
    name,
    setName,
    handleBlinkToggle,
    minusFonthandler,
    fontSize,
    pluseFonthandler,
    color,
    setColor,
    bgColor,
    handlBgcolor,
    handleSpeedChanger,
    handleBlinkSpeedChanger,
    handleFullScreen,
    handleShareUrl,
    blinkSpeend,
    isFlipText,
    setIsFlipText,
    handleSaveAsVideo,
    assertContentAllowed,
    isGeneratingVideo,
    videoProgress,
    progressOwnedByModal
  } = props;
  const [animatedStats, setAnimatedStats] = useState(stats.map(() => 0));

  useEffect(() => {
    // Animate stats
    const intervals = stats.map((stat, i) => setInterval(() => {
      setAnimatedStats(prev => {
        const next = [...prev];
        if (next[i] < stat.value) next[i] += Math.ceil(stat.value / 50);
        if (next[i] > stat.value) next[i] = stat.value;
        return next;
      });
    }, 30));
    return () => intervals.forEach(clearInterval);
  }, []);

  return (
    <>
      <Helmet>
        <title>LED Scroller - LED Banner | Scrolling Text Generator | Digital Signage Online</title>
        <meta name="description" content="Create free scrolling LED banners and digital signage online. LED Scroller, LED Banner, programmable LED sign, scrolling text generator, digital display board, outdoor and indoor LED signs for business, events, and advertising." />
        <meta name="keywords" content="LED Scroller, LED Banner, scrolling text, digital signage, programmable LED sign, LED display board, scrolling LED sign, digital menu board, outdoor LED sign, indoor LED sign, custom LED sign, free LED text generator, LED message board, digital advertising, electronic sign, running text, LED sign software, cloud-based digital signage, digital display, LED sign for business, LED sign for events, LED sign for shop, multilingual LED sign" />
        <link rel="alternate" href="https://ledscroller.com/" hreflang="en" />
      </Helmet>
      {/* Large-screen only left/right vertical AdSense rails */}
      <div className="home-with-side-rails">
        <aside className="home-side-rail home-side-rail-left">
          <GoogleFixedAds
            client={Config.GOOGLE_ADS_CLIENT}
            slot="6893404887"
            format="auto"
            fullWidthResponsive={true}
          />
        </aside>
      <div className="container">
        <div className=''>
          <div className='header-google-ads-row pb-3'>
            <GoogleFixedAds
              // style={{ display: 'inline-block', width: "285px", height: "376px" }}
              client={Config.GOOGLE_ADS_CLIENT}
              slot="7964380148"
              format="auto"
              fullWidthResponsive={true}
            />
          </div>
          <div className='col-12 col-md-8 offset-md-2 p-0 pb-4 pt-2'>
            <a href={Config.ARDRAWING_APP_URL} target='_blank' rel="noreferrer">
              <img src={Config.images.ardrawingBanner} alt="ardrawing banner" className='img-fluid rounded ardrawingBanner' />
            </a>
          </div>
          <TextSliderSection
            onCycleComplete={onCycleComplete}
            RGB={RGB}
            speed={speed}
            isblink={isblink}
            isFlipText={isFlipText}
            name={name}
            setName={setName}
          />

          <TextInputSection
            name={name}
            setName={setName}
            handleFullScreen={handleFullScreen}
            handleShareUrl={handleShareUrl}
            assertContentAllowed={assertContentAllowed}
          />

          <StaticIntroduction
            heading="Tool Introduction : -"
            metaData={metaIntroduction}
          />

          <div className='row pt-5'>
            <div className='col-12 commanUpperFontHeading'>ADJUST LED TEXT BANNER : -</div>

            <div className='row m-0 w-100 pt-4'>
              <div className='col-12 col-sm-12 col-md-9'>
                {/* <BlurEffectCom /> */}
                <div className="d-flex align-items-center w-100 stylesCotainer">
                {/* <div className="blurEffect d-flex align-items-center w-100 stylesCotainer"> */}
                  <label className="font-16 col pl-0 m-0">Text Color : </label>
                  <div className='col-auto d-flex pr-0'>
                    <label className='d-flex m-0'>
                      <div className="cp_wrapper">
                        <input type="color" name="cp_2" value={color} onChange={e => setColor(e.target.value)} />
                      </div>
                      <div className='rightIcon ml-3 d-flex align-items-center'>
                        <img
                          src={Config.images.chevronRight}
                          alt="right icon"
                          width="100%"
                          className='img-fluid'
                        />
                      </div>
                    </label>
                  </div>
                </div>

                <div className='pt-4'>
                  <div className="d-flex align-items-center w-100 stylesCotainer">
                    <label className="font-16 col pl-0 m-0">Background Color : </label>
                    <label className="d-flex m-0">
                      <div className='col-auto pr-0'>
                        <div className="cp_wrapper">
                          <input type="color" name="cp_2" value={bgColor} onChange={e => handlBgcolor(e.target.value)} />
                        </div>
                      </div>
                      <div className='rightIcon ml-3 d-flex align-items-center'>
                        <img
                          src={Config.images.chevronRight}
                          alt="right icon"
                          width="100%"
                          className='img-fluid'
                        />
                      </div>
                    </label>
                  </div>
                </div>

                <div className='pt-4'>
                  <div className="row m-0 align-items-center w-100 stylesCotainer">
                    <div className='col-12 col-sm-12 col-md p-0'>
                      <InputSlider
                        sliderTitle="Text Speed :"
                        selectedValue={speed}
                        handleSlideChanger={handleSpeedChanger}
                        startAdornment={<SpeedIcon />}
                        max={100}
                        step={5}
                        min={10}
                      // marks={speedArray1}
                      />
                    </div>
                  </div>
                </div>

                <div className='pt-4'>
                  <div className="d-flex align-items-center w-100 stylesCotainer">
                    <div>Blink Speed</div>
                    <div className='col-auto p-0'>
                      <FormGroup>
                        <FormControlLabels
                          control={<PurpleSwitch checked={isblink} onChange={handleBlinkToggle} name="checkedA" />}
                          // label="Custom color"
                        />
                      </FormGroup>
                    </div>
                    <div className='col pr-0'>
                      <InputSlider
                        // sliderTitle="Text Speed :"
                        selectedValue={blinkSpeend}
                        handleSlideChanger={handleBlinkSpeedChanger}
                        startAdornment={<SpeedIcon />}
                        max={-30}
                        step={5}
                        min={-1300}
                        isEnableInput={false}
                      // marks={speedArray1}
                      />
                    </div>
                  </div>
                </div>
                <div className='pt-4'>
                  {/* <div className='blurLayer'></div> */}
                  <div className='stylesCotainer'>
                    <div className="row m-0 align-items-center w-100 ">
                    <div className='col-6 text-center'>Mirror Text</div>
                    <div className='col-6 text-center'>Text Size</div>
                    </div>
                    <div className="row m-0 align-items-center w-100 ">
                      <div className='col-6'>
                        <div className='d-flex justify-content-center align-items-center'>
                          <div className=''>

                            <div className='col-auto p-0'>
                              <FormGroup>
                                <FormControlLabels
                                  control={<MirrorSwitch checked={isFlipText} onChange={() => setIsFlipText(!isFlipText)} name="checkedA" />}
                                  // label="Custom color"
                                />
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-6 px-0 px-md-3'>
                        <div className='col-12 col-sm-12 col-md-auto px-0 px-md-3'>

                          <div className='col volumeSettings p-0 d-flex justify-content-center align-items-center'>
                            <button type='button' className='noselect ml-0 position-relative' onClick={minusFonthandler}><div>-</div></button>
                            <div>{fontSize}</div>
                            <button type='button' className='noselect mr-0 position-relative' onClick={pluseFonthandler}><div>+</div></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row m-0 pt-4'>
                  <div className="col-12 col-sm-12 col-md-6 pl-0 pr-0 pr-md-2">
                    <button className="glow-on-hover w-100" type="button" onClick={handleShareUrl}>
                      <img
                      src={Config.images.externalLink}
                      alt="right icon"
                      width="100%"
                      className='buttonIcon img-fluid'
                    />
                      Want Share!
                    </button>
                  </div>
                  <div className='col-12 col-sm-12 col-md-6 pr-0 pl-0 pl-md-2 pt-3 pt-md-0'>
                    <button 
                      className="glow-on-hover w-100 h-100" 
                      type="button" 
                      onClick={handleSaveAsVideo}
                      disabled={isGeneratingVideo}
                      style={{ position: 'relative', opacity: isGeneratingVideo ? 0.7 : 1 }}
                    >
                      <img
                        src={Config.images.downlaodIcon}
                        alt="download icon"
                        width="100%"
                        className='buttonIcon img-fluid'
                      />
                      {isGeneratingVideo
                        ? (progressOwnedByModal
                          ? 'Preparing download…'
                          : `Generating Video... ${videoProgress}%`)
                        : 'Save as Video'}
                      {isGeneratingVideo && !progressOwnedByModal && (
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: '3px',
                          background: Config.THEME_COLOR,
                          width: `${videoProgress}%`,
                          transition: 'width 0.3s ease'
                        }} />
                      )}
                    </button>
                  </div>
                </div>  
              </div>

              <div className='col-12 col-sm-12 col-md-3 m-auto' >
                <div className='homesidebar-googleFixedAds'>
                  <div>
                    <GoogleFixedAds
                      style={{ display: 'inline-block', width: "285px", height: "376px" }}
                      client={Config.GOOGLE_ADS_CLIENT}
                      slot="9765048026"
                      format="auto"
                      fullWidthResponsive={true}
                    />
                  </div>
                  {/* <div className='col-12 col-sm-12 col-md-12 pt-5 pt-md-0'> */}
                {/* <div className='row m-0 justify-content-center socialIconSection'> */}
                  {/* <div className='col-6 col-md-12 pr-2 pl-0 py-md-2 px-md-4'>
                    <a target="_blank" rel="noreferrer" href='https://apps.apple.com/us/app/id6443862073'>
                      <img
                        src={Config.images.appstore}
                        alt="right icon"
                        width="100%"
                        className='img-fluid'
                      />
                    </a>
                  </div> */}
                  <div className='col-6 m-auto col-md-12 pl-2 pr-0 py-md-2 px-md-4'>
                    <a target="_blank" rel="noreferrer" href='https://play.google.com/store/apps/details?id=com.james.ledscroller.ledbanner.ledsign&hl=en&gl=US'>
                      <img
                        src={Config.images.playstore}
                        alt="right icon"
                        width="100%"
                        className='img-fluid'
                      />
                    </a>
                  </div>
                {/* </div> */}
              {/* </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className='pt-4 pt-md-5 row'>
             {/* game banner section */}
             <div className='col- 12 col-md-8 offset-md-2'>
              <section className="how-it-works-section" style={{background: Config.THEME_BG_COLOR, borderRadius: 16}}>
                <Fade direction="right" triggerOnce>
                  <h2 className='pb-3' style={{textAlign: 'center', color: Config.THEME_COLOR}}>Game Community</h2>
                    <a href='https://snapmindgames.com' target='_blank' rel="noreferrer">
                      <div className=''>
                        <img src={Config.images.gameBanner} alt="game banner" className='img-fluid rounded ' />
                      </div>
                    </a>
                </Fade>
              </section>
             </div>
          </div>
          
          <div className='pt-4'>
             {/* How It Works */}
             <section className="how-it-works-section" style={{background: Config.THEME_BG_COLOR, padding: '2rem 0', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="right" triggerOnce>
                <h2 style={{textAlign: 'center', color: Config.THEME_COLOR}}>How It Works</h2>
                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: 30}}>
                  {[
                    {icon: '📝', text: 'Enter your message'},
                    {icon: '🎨', text: 'Customize colors, fonts, speed'},
                    {icon: '👀', text: 'Preview instantly'},
                    {icon: '💾', text: 'Save or share'},
                    {icon: '📺', text: 'Use full-screen for events'},
                  ].map((step, i) => (
                    <div key={i} style={{flex: '1 1 150px', minWidth: 150, maxWidth: 180, margin: '1rem', textAlign: 'center'}}>
                      <div style={{fontSize: '2.2rem'}}>{step.icon}</div>
                      <div style={{fontWeight: 600, marginTop: 8, color: '#fff'}}>{step.text}</div>
                    </div>
                  ))}
                </div>
                
                <div className='row pt-4'>
                  <div className='col-12 d-flex justify-content-center'>
                    <div className='google-ads-container'>
                      <div className='google-ads-responsive'>
                        <GoogleFixedAds
                          style={{ display: 'block', width: '100%', height: 'auto' }}
                          client={Config.GOOGLE_ADS_CLIENT}
                          slot="8070544512"
                          format="auto"
                          fullWidthResponsive={true}
                        />    
                      </div>
                    </div>
                  </div>
                </div>
                <div className='video-iframe'>
                  <iframe  
                    src="https://www.youtube.com/embed/xNH2iZq7v08" 
                    width="100%" 
                    height="500"
                    style={{maxWidth: 900, borderRadius: 12, margin: '2rem auto', display: 'block'}}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    title="LED Scroller Demo Video"
                  ></iframe>
                </div>
              </Fade>
            </section>
            <StaticIntroduction
              heading="How Does LED Scroller Work ?"
              metaData={metaDiscription}
            />
          </div>

          <div className='pt-4'>
            {/* Features Row */}
            <section className="features-row" style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', background: Config.THEME_BG_COLOR, color: '#fff', padding: '2rem 0', borderRadius: 16, marginBottom: '2rem'}}>
              {features.map((f, i) => (
                <Fade direction="up" delay={i * 100} triggerOnce key={f.title}>
                  <div style={{flex: '1 1 200px', maxWidth: 250, margin: '1rem', textAlign: 'center'}}>
                    <div style={{fontSize: '2.5rem', marginBottom: 10}}>{f.icon}</div>
                    <div style={{fontWeight: 700, fontSize: '1.1rem', color: Config.THEME_COLOR}}>{f.title}</div>
                    <div style={{fontSize: '1rem', color: '#bbb', marginTop: 6}}>{f.desc}</div>
                  </div>
                </Fade>
              ))}
            </section>
            <StaticIntroduction
              heading="More About Application"
              metaData={moreAbout}
            />
          </div>

          <div className="row pt-5 why-choose-section">
             {/* Why Choose Us */}
             <section className="why-choose-section" style={{background: Config.THEME_BG_COLOR, color: '#fff', padding: '3rem 0', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="up" triggerOnce>
                <h2 style={{textAlign: 'center', color: Config.THEME_COLOR}}>Why Choose Us?</h2>
                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: 30}}>
                  {whyChoose.map((item, i) => (
                    <div key={i} style={{flex: '1 1 200px', minWidth: 200, maxWidth: 250, margin: '1rem', textAlign: 'center'}}>
                      <div style={{fontSize: '2.2rem'}}>{item.icon}</div>
                      <div style={{fontWeight: 700, marginTop: 8, color: Config.THEME_COLOR}}>{item.title}</div>
                      <div style={{fontSize: '1rem', marginTop: 6, color: '#bbb'}}>{item.desc}</div>
                    </div>
                  ))}
                </div>
              </Fade>
            </section>
            <div className="col-12 pb-4">
              <ul>
                <li>Instantly create eye-catching LED banners for any occasion</li>
                <li>Highly customizable: colors, fonts, speed, and more</li>
                <li>Mobile-friendly and works on all devices</li>
                <li>Share your creations easily with friends or on social media</li>
                <li>No sign-up required and privacy-friendly</li>
              </ul>
            </div>
          </div>

          <div className="row pt-4 user-say-section">
            <div className="col-12 commanUpperFontHeading pb-2">What Our Users Say</div>
            <div className="col-12 pb-4">
              <blockquote>"This app made my event stand out! Super easy to use and looks amazing." <br/> <span>- Priya S.</span></blockquote>
              <blockquote>"I use the LED scroller for my shop promotions. Customers love it!" <br/> <span>- Rahul K.</span></blockquote>
              <blockquote>"The customization options are fantastic. Highly recommended!" <br/> <span>- Emily W.</span></blockquote>
            </div>
          </div>
          {/* About/Our Story */}
            <section className="about-section" style={{background: Config.THEME_BG_COLOR, padding: '3rem 0', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="left" triggerOnce>
                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', maxWidth: 1100, margin: '0 auto'}}>
                  <div style={{flex: '1 1 350px', minWidth: 300, padding: 20, textAlign: "right"}}>
                    <h2 style={{color: Config.THEME_COLOR}}>Our Story</h2>
                    <p style={{fontSize: '1.1rem', color: '#bbb'}}>LED Scroller was created to help anyone make stunning, animated LED banners for any purpose—business, events, or fun. Our mission is to make digital signage accessible, customizable, and privacy-friendly for everyone.</p>
                    <a href="/about" style={{color: Config.THEME_COLOR, fontWeight: 600}}>Learn more about us →</a>
                  </div>
                  <div style={{flex: '1 1 100px', minWidth: 300, textAlign: 'center'}}>
                    <img src={Config.images.storefront} alt="About LED Scroller" style={{width: '100%', maxWidth: 350, borderRadius: 12}} />
                  </div>
                </div>
              </Fade>
            </section>

           

           

            {/* Animated Stats */}
            <section className="stats-section" style={{background: Config.THEME_BG_COLOR, padding: '2.5rem 0', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="up" triggerOnce>
                <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', maxWidth: 900, margin: '0 auto'}}>
                  {stats.map((stat, i) => (
                    <div key={stat.label} style={{flex: '1 1 180px', minWidth: 180, margin: '1rem', textAlign: 'center'}}>
                      <div style={{fontSize: '2.2rem', color: Config.THEME_COLOR, fontWeight: 700}}>{animatedStats[i]}</div>
                      <div style={{fontWeight: 600, color: '#fff'}}>{stat.label}</div>
                    </div>
                  ))}
                </div>
              </Fade>
            </section>
          <div className="row pt-4 how-to-use-section">
            <div className="col-12 commanUpperFontHeading pb-2">How to Use the LED Scroller</div>
            <div className="col-12 pb-4">
              <ol>
                <li>Enter your message in the text box above.</li>
                <li>Customize the text color, background, speed, and font size.</li>
                <li>Preview your LED banner instantly.</li>
                <li>Save or share your creation with a single click.</li>
                <li>Use full-screen mode for events or presentations.</li>
              </ol>
            </div>
          </div>

          <div className="row pt-4">
            <div className="col-12 commanUpperFontHeading pb-2">LED Display Style Examples</div>
            <div className="col-12 d-flex flex-wrap justify-content-between pb-4">
              <div style={{background:'#111', color:'#0ff', padding:'20px', borderRadius:'10px', margin:'10px', minWidth:'220px', flex:'1 1 220px', textAlign:'center', fontFamily:'monospace', fontSize:'1.5rem'}}>WELCOME!</div>
              <div style={{background:'#222', color:'#ff0', padding:'20px', borderRadius:'10px', margin:'10px', minWidth:'220px', flex:'1 1 220px', textAlign:'center', fontFamily:'cursive', fontSize:'1.5rem'}}>SALE NOW ON</div>
              <div style={{background:'#333', color:'#f0f', padding:'20px', borderRadius:'10px', margin:'10px', minWidth:'220px', flex:'1 1 220px', textAlign:'center', fontFamily:'serif', fontSize:'1.5rem'}}>🎉 PARTY TIME 🎉</div>
              <div style={{background:'#000', color:'#fff', padding:'20px', borderRadius:'10px', margin:'10px', minWidth:'220px', flex:'1 1 220px', textAlign:'center', fontFamily:'sans-serif', fontSize:'1.5rem'}}>OPEN 24/7</div>
            </div>
          </div>

          {/* --- New UI Sections Start Here --- */}
          <div style={{width: '100%', margin: '0 auto', marginTop: '2rem'}}>
            {/* Hero Section */}
            {/* <section className="hero-section" style={{background: Config.THEME_BG_COLOR, color: '#fff', padding: '3rem 0', textAlign: 'center', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="down" triggerOnce>
                <h1 style={{fontSize: '2.8rem', fontWeight: 700, color: Config.THEME_COLOR}}>Welcome to LED Scroller</h1>
                <p style={{fontSize: '1.3rem', margin: '1rem auto', maxWidth: 600, color: '#fff'}}>
                  Instantly create eye-catching LED banners and scrolling text for your business, event, or personal use. Free, easy, and works on any device.
                </p>
                <img src={demoImages[0]} alt="LED Banner Example" style={{width: '100%', maxWidth: 600, borderRadius: 12, margin: '2rem auto'}} />
              </Fade>
            </section> */}

            

            

            {/* FAQ Section */}
            <section className="faq-section" style={{background: Config.THEME_BG_COLOR, padding: '3rem 0', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="left" triggerOnce>
                <h2 style={{textAlign: 'center', color: Config.THEME_COLOR}}>Frequently Asked Questions</h2>
                <div style={{maxWidth: 800, margin: '2rem auto'}}>
                  {faqs.map((faq, i) => (
                    <div key={i} style={{marginBottom: 24}}>
                      <div style={{fontWeight: 700, color: Config.THEME_COLOR}}>{faq.q}</div>
                      <div style={{marginLeft: 10, color: '#fff'}}>{faq.a}</div>
                    </div>
                  ))}
                </div>
              </Fade>
            </section>

            {/* Call to Action */}
            {/* <section className="cta-section" style={{background: Config.THEME_BG_COLOR, color: '#fff', padding: '2.5rem 0', textAlign: 'center', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="up" triggerOnce>
                <h2 style={{color: Config.THEME_COLOR}}>Ready to create your LED banner?</h2>
                <p style={{fontSize: '1.2rem', margin: '1rem auto', maxWidth: 600}}>Get started now or contact us for support.</p>
                <a href="/contact" style={{background: Config.THEME_COLOR, color: '#fff', padding: '0.8rem 2rem', borderRadius: 8, fontWeight: 700, fontSize: '1.1rem', textDecoration: 'none'}}>Contact Us</a>
              </Fade>
            </section> */}

            {/* Blog/Resources */}
            <section className="blog-section" style={{background: Config.THEME_BG_COLOR, padding: '2.5rem 0', borderRadius: 16, marginBottom: '2rem'}}>
              <Fade direction="up" triggerOnce>
                <h2 style={{textAlign: 'center', color: Config.THEME_COLOR}}>Read Our Blog</h2>
                <p style={{textAlign: 'center', maxWidth: 700, margin: '1rem auto', color: '#fff'}}>Discover tips, tricks, and inspiration for your LED banners. <a href='/blog' style={{color: Config.THEME_COLOR, fontWeight: 600}}>Visit the blog</a>.</p>
              </Fade>
            </section>
          </div>
          {/* --- New UI Sections End Here --- */}

          <div className='row pt-4'>
            <div className='col-12 d-flex justify-content-center'>
              <div className='google-ads-container'>
                <div className='google-ads-responsive'>
                  <GoogleFixedAds
                    style={{ display: 'block', width: '100%', height: 'auto' }}
                    client={Config.GOOGLE_ADS_CLIENT}
                    slot="3506080217"
                    format="autorelaxed"
                  />    
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <aside className="home-side-rail home-side-rail-right">
          <GoogleFixedAds
            client={Config.GOOGLE_ADS_CLIENT}
            slot="2379444806"
            format="auto"
            fullWidthResponsive={true}
          />
        </aside>
      </div>

      <style>{`
      .screenImage{
        background: url('${Config.images.screenImage}');
        height: calc(100vh);
        background-repeat: no-repeat;
        background-attachment: inherit;
        background-size: cover;
        background-size: 100% 100%;
        background-position: center;
        flex-direction: column;
        display: flex;
        overflow: auto;
      }

      .mirrorText {
        transform: scale(-1, 1);
      }

      .marquee-container {
        overflow: hidden;
      }

      .selectOption{
        width: 100%;
        background: #282c34;
        border: 1px solid #a2a2a2;
        border-radius: 4px;
        color: #fff;
        font-size: 15px;
        padding: 7px;
        /* margin-right: 13px; */
        appearance: none;
        background-repeat: no-repeat;
        background-position: right 1rem center;
        background-size: 1em;
        background-image: url('${Config.images.downArrow}');
      }

      .blink_me {
        animation: blinker ${Math.abs(blinkSpeend)}0ms linear infinite;
      }

      .overlayScreenImage{
        border: 5px solid #727272;
        border-radius: 8px;
        position: relative;
        height: 269px;
        background: url('${Config.images.screenImage}');
        background-repeat: repeat;
        background-attachment: inherit;
        background-size: 100%;
        background-position: center;
        overflow: auto;
        width: 100%;
        position: absolute;
        z-index: 99;
      }

      .outerBox{
        width: 100%;
        position: relative;
        height: 269px;
        color: ${color};
        background-color: ${bgColor};
        align-items: center;
        justify-content: center;
        background:${bgColor};
        flex-direction: column;
        display: flex;
        border-radius: 8px;
        overflow: auto;
        // font-size: ${isMobile ? fontSize * 2 : fontSize * 3}px;
      }

      .sliderFontSize{
        font-size: ${isMobile ? fontSize * 2.5 : fontSize * 3.3}px;
        font-weight: 900;
      }

      .marquee{
        padding-bottom: ${isMobile ? '21' : '20'}px;
      }

      @media screen and (max-width: 992px) {
        body {
          background-color: blue;
        }
      }

      @media screen and (min-width: 1240px) {
        .outerBox{
          width: 100%;
          height: 331px;
        }
        .overlayScreenImage{
          border: 5px solid #727272;
          width: 100%;
          height: 100%;
          background-size: 70%;
          border-radius: 8px;
        }
      }

      /* On screens that are 600px or less, set the background color to olive */
      @media screen and (max-width: 900px) and (orientation : landscape) {
        .outerBox{
          width: 100%;
          height: 331px;
        }
        .overlayScreenImage{
          border: 5px solid #727272;
          border-radius: 8px;
          width: 100%;
          height: 331px;
        }
      }

      `}</style>
    </>
  )
}

export default Home
